import { FileText, Lock, Mail, ExternalLink } from 'lucide-react';
import { useState } from 'react';

type Tab = 'impressum' | 'datenschutz' | 'hilfe';

export function ImpressumPage() {
  const [tab, setTab] = useState<Tab>('impressum');

  const tabs: { key: Tab; label: string }[] = [
    { key: 'impressum', label: 'Impressum' },
    { key: 'datenschutz', label: 'Datenschutz' },
    { key: 'hilfe', label: 'Hilfe' },
  ];

  return (
    <div className="space-y-6 max-w-3xl">
      <h1 className="text-2xl font-bold text-slate-900">Mehr</h1>

      <div className="flex gap-1 bg-slate-100 rounded-lg p-1">
        {tabs.map(({ key, label }) => (
          <button
            key={key}
            onClick={() => setTab(key)}
            className={`px-4 py-2 rounded-md text-sm font-medium transition flex-1 ${
              tab === key ? 'bg-white shadow-sm text-rla-500' : 'text-slate-600 hover:text-slate-900'
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      {tab === 'impressum' && (
        <div className="card prose prose-sm prose-slate max-w-none">
          <div className="flex items-center gap-2 mb-4">
            <FileText size={18} className="text-rla-500" />
            <h2 className="text-lg font-semibold m-0">Impressum</h2>
          </div>
          <p className="text-slate-600">
            <strong>RLA Digital Solutions</strong><br />
            Alex Bezsch<br />
            {/* Adresse hier ergänzen */}
            E-Mail: alex.bezsch@gmail.com
          </p>
          <p className="text-sm text-slate-500">
            Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:<br />
            Alex Bezsch
          </p>
        </div>
      )}

      {tab === 'datenschutz' && (
        <div className="card prose prose-sm prose-slate max-w-none">
          <div className="flex items-center gap-2 mb-4">
            <Lock size={18} className="text-rla-500" />
            <h2 className="text-lg font-semibold m-0">Datenschutzerklärung</h2>
          </div>
          <h3>1. Verantwortlicher</h3>
          <p>RLA Digital Solutions, Alex Bezsch (alex.bezsch@gmail.com)</p>

          <h3>2. Erhobene Daten</h3>
          <p>
            Dieses Dashboard verarbeitet nur Daten, die für den Betrieb notwendig sind:
            E-Mail-Adresse, IP-Adresse bei Login, Session-Daten in Redis (serverseitig, kein JWT).
          </p>

          <h3>3. Verschlüsselung</h3>
          <p>
            Alle Verbindungen sind TLS 1.3 verschlüsselt. Passwörter werden mit Argon2id gehasht.
            TOTP-Secrets und sensible Daten werden mit AES-256-GCM verschlüsselt.
          </p>

          <h3>4. Cookies</h3>
          <p>
            Es wird ein Session-Cookie (<code>__Host-rla_dashboard_sid</code>) gesetzt.
            Dieses Cookie ist HttpOnly, Secure, SameSite=Strict — kein Tracking.
          </p>

          <h3>5. Löschung</h3>
          <p>Sessions werden nach 24h / 7 Tagen automatisch gelöscht. Account-Löschung auf Anfrage.</p>
        </div>
      )}

      {tab === 'hilfe' && (
        <div className="card space-y-4">
          <h2 className="text-lg font-semibold">Hilfe</h2>

          <div className="space-y-3">
            <a
              href="https://cloud.rla-solutions.de"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 p-3 rounded-md border border-slate-200 hover:border-rla-500 transition"
            >
              <div className="p-2 rounded bg-blue-50 text-blue-600"><FileText size={16} /></div>
              <div className="flex-1">
                <div className="font-medium text-sm">RLA Cloud</div>
                <div className="text-xs text-slate-500">Datei-Cloud öffnen</div>
              </div>
              <ExternalLink size={14} className="text-slate-400" />
            </a>

            <a
              href="https://email.rla-solutions.de"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 p-3 rounded-md border border-slate-200 hover:border-rla-500 transition"
            >
              <div className="p-2 rounded bg-emerald-50 text-emerald-600"><Mail size={16} /></div>
              <div className="flex-1">
                <div className="font-medium text-sm">RLA Mail</div>
                <div className="text-xs text-slate-500">Webmail öffnen</div>
              </div>
              <ExternalLink size={14} className="text-slate-400" />
            </a>
          </div>

          <div className="mt-4 p-4 bg-slate-50 rounded-md">
            <h3 className="font-medium text-sm mb-2">Kontakt bei Problemen</h3>
            <p className="text-sm text-slate-600">
              E-Mail: <a href="mailto:alex.bezsch@gmail.com" className="text-rla-500 hover:underline">alex.bezsch@gmail.com</a>
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
